import { Injectable, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { AlertType } from '../alert.model';

@Injectable()
export class DialogService  {

  @ViewChild(AlertDialogComponent) alert: AlertDialogComponent;

  constructor(
    public dialog: MatDialog
  ) {  }

  confirm(titol: string, text: string): Observable<boolean> {
    // const confirmation = window.confirm(message || 'Estàs segur?');
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '400px',
      data: {titol: titol, text: text, tipus: AlertType.Warning, botoAcceptar: true, botoCancelar: true}
    });

    return dialogRef.afterClosed();
  };


  show(titol: string, missatge: string, tipus: AlertType) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '400px',
      data: {titol: titol, text: missatge, tipus: tipus, botoAcceptar: true, botoCancelar: false}
    });
  }

  showSpin(titol: string, missatge: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      width: '400px',
      data: {titol: titol, text: missatge, tipus: AlertType.Info, botoAcceptar: false, botoCancelar: false, showSpin: true}
    });
  }


  hide() {
    this.dialog.closeAll();
  }
} 


